import React from 'react';
import { TbCircleCheck } from 'react-icons/tb';
import { ImCancelCircle } from 'react-icons/im';
import './MessageModal.css';

export const MessageModal = ({ variant, message, onClose }) => {
  const getIcon = () => {
    if (variant === 'success') {
      return <TbCircleCheck color="#32D16D" size={60} />;
    }
    return <ImCancelCircle color="#FA041D" size={60} />;
  };

  const getTitle = () => {
    if (variant === 'success') {
      return 'Operação realizada com sucesso!';
    }
    return 'Ocorreu um erro!';
  };

  const getSubtitle = () => {
    if (variant === 'success') {
      return 'Em alguns momentos, o processo será finalizado!';
    }
    return 'Tente novamente em alguns minutos.';
  };

  return (
    <div className="message-modal-container">
      <div
        className="message-modal-header"
        style={{ display: 'flex', alignItems: 'center', gap: '15px' }}
      >
        {getIcon()}
        <div>
          <h1 style={{ fontSize: '1.5rem', margin: 0 }}>{getTitle()}</h1>
          <span style={{ fontSize: '0.9rem', color: '#666' }}>
            {getSubtitle()}
          </span>
        </div>
      </div>
    </div>
  );
};
